/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Link from 'gatsby-link';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const BlogCard = ({ post, imagesArray }) => {
  const Tags = (post.frontmatter && post.frontmatter.tags) || [];
  return (
    <article className="blog-post-card">
      <div className="blog-tags-cont">
        {Tags.map((tag, i) => (
          <Link key={i} to={`/blog/tags/${_.kebabCase(tag.name)}`}>
            {tag.name}
          </Link>
        ))}
      </div>

      <Link to={post.frontmatter.path}>
        <h1 className="is-size-3">{post.frontmatter.title}</h1>
        <p className="blog-card-summary">{post.frontmatter.summary}</p>
      </Link>
      <div className="blog-post-author-cont">
        <img
          alt
          width={30}
          height={30}
          src="/files/images/new/michelle-barker.jpg"
        />
        <a href="/contributors/michelle-barker/">{post.frontmatter.author}</a> on {post.frontmatter.date}
      </div>
    </article>

    // <article>
    //   <div xs="12" sm="12">
    //     <ul>
    //       {Tags.map((tag, i) => (
    //         <Link key={i} to={`/blog/tags/${_.kebabCase(tag.name)}`}>
    //           {tag.name}
    //         </Link>
    //       ))}
    //     </ul>
    //   </div>
    //   <div xs="12" sm="7">
    //     <h1>{post.frontmatter.title}</h1>
    //     <pre>
    //       {post.frontmatter.author} on {post.frontmatter.date}
    //     </pre>
    //     <p>{post.frontmatter.summary}</p>
    //   </div>
    //   {typeof window !== 'undefined' && (
    //     <div xs="12" sm="5">
    //       {imagesArray
    //         .filter(item => item.relativePath === post.frontmatter.postimage.slice(14))
    //         .map(
    //           (item, i) =>
    //             item.childImageSharp ? (
    //               <Img key={i} sizes={item.childImageSharp.sizes} />
    //             ) : (
    //               <LazyLoadImage key={i} effect="blur" src={post.frontmatter.postimage} width="100%" />
    //             ),
    //         )}
    //     </div>
    //   )}
    //   <div xs="12" sm="12">
    //     <Link to={post.frontmatter.path}>Read more</Link>
    //   </div>
    // </article>
  );
};

BlogCard.propTypes = {
  post: PropTypes.object,
  imagesArray: PropTypes.array,
};

export default BlogCard;



// WEBPACK FOOTER //
// ./src/components/BlogCard.js